import { m } from '@hub/messages';
import { definePageRoute } from '@hub/router/definePageRoute';
import { type DomainParents, defineDomainRoutes } from '@hub/router/domain-routes';
import { getBookingSessionQueryOptions } from './bookingSession.queryOptions';
import { ConfiguratorPaths } from './route.paths';

export default function createConfiguratorRoutes(parents: DomainParents) {
  const configuratorRoute = definePageRoute(parents, {
    path: ConfiguratorPaths.configure,
    title: m.configurator_page_title,
    description: m.configurator_page_meta_description,
    theme: 'dark',
    shellWidth: 'wide',
    flag: 'page-configurator',
    page: () => import('./Configurator.page'),
    pendingComponent: () => import('./components/ConfiguratorSkeleton'),
    query: getBookingSessionQueryOptions,
    // don't create a session on hover-preload
    preload: false,
  });

  return defineDomainRoutes({
    authenticated: [] as const,
    public: [configuratorRoute] as const,
  });
}
